export const getInitials = (name: string) => {
  const cleaned = (name || '').trim();
  if (!cleaned) {
    return '';
  }

  const parts = cleaned.split(/\s+/).filter(Boolean);
  if (parts.length >= 2) {
    return `${parts[0][0] ?? ''}${parts[1][0] ?? ''}`.toUpperCase();
  }

  return cleaned.slice(0, 2).toUpperCase();
};
